module.exports = __webpack_public_path__ + "mo/img/mo_logo.a59e7466.svg";